<template>
  <!-- Início Wrapper -->
  <div class="wrapper bg-login-main">
    <!-- Início Página Esqueci a Senha -->
    <div class="m-account-w">
      <div class="m-account">
        <div class="row no-gutters">
          <div class="col-md-6">
            <!-- Início Textos Esqueci a Senha -->
            <div class="m-account--content-w bg-login-right">
              <div class="m-account--content">
                <h2 class="h2">Já tem uma conta?</h2>
                <p></p>
                <a href="../login" class="btn btn-cadastro">FAÇA LOGIN</a>
              </div>
            </div>
            <!-- Fim Textos Esqueci a Senha -->
          </div>

          <div class="col-md-6">
            <!-- Início Form Esqueci a Senha -->
            <div class="m-account--form-w">
              <div class="m-account--form">
                <!-- Início Logo -->
                <div class="logo">
                  <img src="../../assets/images/logo.png" alt="" />
                </div>
                <!-- Fim Logo -->

                <form>
                  <p class="m-account--title">Esqueceu a senha?</p>

                  <p class="m-account--subtitle">
                    Informe o seu e-mail e enviaremos as instruções para você
                    criar uma nova senha.
                  </p>

                  <div class="form-group input-senha">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <i class="fas fa-envelope"></i>
                      </div>

                      <input-text
                        placeholder="Usuario ou e-mail"
                        autocomplete="off"
                        required
                        v-model="form.nomeUsuario"
                      />
                    </div>
                  </div>

                  <div class="form-group pt-3">
                    <p class="text-black-50">
                      Não lembra qual e-mail está cadastrado?<br />
                      <a href="#">Fale com o suporte</a>
                    </p>
                  </div>

                  <div class="m-account--actions">
                    <b-button
                      @click="resetarSenha"
                      class="btn btn-primary mx-auto"
                      >MUDAR A SENHA</b-button
                    >
                  </div>

                  <div class="m-account--footer">
                    <p>
                      Powered By <span><a href="#">Jordão Energia</a></span>
                    </p>
                  </div>
                </form>
              </div>
            </div>
            <!-- Fim Form Esqueci a Senha -->
          </div>
        </div>
      </div>
    </div>
    <!-- Fim Página Esqueci a Senha -->
  </div>
  <!-- Fim Wrapper -->
</template>

<script>
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import InputText from "@/components/inputs/InputText";
import UsuarioService from "@/common/services/usuario/usuario.service";
import Swal from "sweetalert2";

export default {
  name: "Login",
  components: {
    InputText,
  },
  data() {
    return {
      form: {
        nomeUsuario: null,
      },
    };
  },
  computed: {
    validarSenha() {
      if (!this.comparaSenha()) return false;
      return true;
    },
  },
  methods: {
    validarFormulario() {
      let arValidation = [];
      arValidation.push(this.$refs.novaSenha.valid());
      arValidation.push(this.$refs.senha.valid());

      return arValidation.filter((elem) => elem == false).length == 0;
    },
    resetarSenha() {
      // if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);
      const form = this.form;
      UsuarioService.esqueceuSenha(form)
        .then(() => {
          Swal.fire({
            title: this.$t("GERAL.SUCCESSO"),
            text: this.$t("GERAL.EMAIL_ENVIADO"),
            icon: "success",
            confirmButtonText: this.$t("GERAL.OK"),
          }).then(() => {
            this.$router.push({ name: "Login" });
          });
        })
        .catch((err) => {
          Swal.fire({
            title: this.$t("GERAL.ERRO"),
            text: err.response.data.errors,
            icon: "error",
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    comparaSenha() {
      if (this.form.senha !== this.form.novaSenha) {
        return false;
      }
      return true;
    },
    voltarLogin() {
      this.$router.push({ name: "Login" });
    },
  },
};
</script>
<style>
.input-senha .col-form-label {
  padding-bottom: 0px;
}
</style>
